import { useEffect, useRef } from 'react';
import styles from './NoizeGraf.module.css';

const barCount = 450;
const barCountOne = barCount / 3;
const BAR_SPACING = 10;
// Константа BORDER_RADIUS удалена — скругления больше нет

const colors = [
  ...Array(barCountOne).fill('#ff0048'), // красный (верхний диапазон)
  ...Array(barCountOne).fill('#ffff00'), // жёлтый (средний)
  ...Array(barCountOne).fill('#36ff07'), // зелёный (нижний)
];

// Пороги рассчитываются в обратном порядке (справа налево)
const barThresholds = Array(barCount)
  .fill(0)
  .map((_, index) => {
    const barPosition = barCount - (index + 1);
    return {
      threshold: (barPosition / barCount) * 100,
      prevThreshold: ((barPosition + 1) / barCount) * 100,
    };
  });

export const NoizeGraf2 = ({
  noiseLevel = 40,
  CANVAS_WIDTH = 26942,
  CANVAS_HEIGHT = 120,
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    // Предварительные расчёты геометрии
    const barWidth = width / barCount;
    const actualBarWidth = barWidth - BAR_SPACING;
    const stepPercentage = 100 / barCount; // шаг одного бара в процентах

    // Очистка холста
    ctx.clearRect(0, 0, width, height);

    const targetLevel = Math.min(Math.max(noiseLevel, 0), 100);

    // Отрисовка баров
    for (let index = 0; index < barCount; index++) {
      const color = colors[index];
      const x = index * barWidth;
      const { threshold, prevThreshold } = barThresholds[index];

      // Вычисление доли заполнения текущего бара (от 0 до 1)
      let fillPercentage = 0;
      if (targetLevel >= threshold) {
        fillPercentage = 1; // полностью заполнен
      } else if (targetLevel > prevThreshold) {
        fillPercentage = (targetLevel - prevThreshold) / stepPercentage;
      }

      // Если бар должен быть заполнен — рисуем прямоугольник
      if (fillPercentage > 0) {
        const fillWidth = actualBarWidth * fillPercentage;
        // Заполнение идёт справа (для обратного порядка)
        const fillX = x + (actualBarWidth - fillWidth);

        ctx.fillStyle = color;
        ctx.fillRect(fillX, 0, fillWidth, height);
      }
    }
  }, [noiseLevel]);

  return (
    <div className={styles.noiseGraf}>
      <canvas
        ref={canvasRef}
        width={CANVAS_WIDTH}
        height={CANVAS_HEIGHT}
        className={styles.noizeCanvas}
      />
    </div>
  );
};
